// common
import { memo } from 'react';
import clsx from 'clsx';

// styles
import styles from './style';

// import CheckboxIconUnselected from '../../../assets/icons/checkbox-unselected.svg'
// import CheckboxIcon from '../../../assets/icons/checkbox-selected.svg'

// Props Interface
export interface CheckboxProps {
  className?: any;
  style?: any;
  checked?: boolean;
  disabled?: boolean;
  onClick?: any;

  type?: any;
  text?: string | any;
  textStyle?: any;
  textClassName?: any;
  onTextPress?: any;
}

export const ICON_TYPES = {
  DEFAULT: 'DEFAULT',
  DEFAULT_INVERTED: 'DEFAULT_INVERTED',
  CIRCLE: 'CIRCLE',
};

const Checkbox = (props: CheckboxProps) => {
  const isHTML = (text) => {
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return [...doc.body.childNodes].some((node) => node.nodeType === 1); // 1 = ELEMENT_NODE
  };

  return (
    <div
      className={clsx([props.className, 'cursor-pointer'])}
      style={{ ...styles.container, ...props.style }}
      onClick={() => {
        props.onClick(!props.checked);
      }}
    >
      <div
        className=""
        style={{
          ...styles.iconContainer,
          ...{ minWidth: styles.icon.width, minHeight: styles.icon.height },
        }}
      >
        {props.checked ? (
          <>
            {props.type == null || props.type == ICON_TYPES.DEFAULT ? (
              <img
                style={{
                  width: styles.icon.width,
                  height: styles.icon.height,
                }}
                src="/assets/icons/checkbox-selected.svg"
              />
            ) : null}

            {props.type == ICON_TYPES.DEFAULT_INVERTED ? (
              <img
                style={{
                  width: styles.icon.width,
                  height: styles.icon.height,
                }}
                src="/assets/icons/checkbox-selected-inverted.svg"
              />
            ) : null}

            {props.type == ICON_TYPES.CIRCLE ? (
              <img
                style={{
                  width: styles.icon.width,
                  height: styles.icon.height,
                }}
                src="/assets/icons/checkbox-circle-selected.svg"
              />
            ) : null}
          </>
        ) : (
          <>
            {props.type == null || props.type == ICON_TYPES.DEFAULT ? (
              <img
                style={{
                  width: styles.icon.width,
                  height: styles.icon.height,
                  color: 'black',
                }}
                src="/assets/icons/checkbox-unselected.svg"
              />
            ) : null}

            {props.type == ICON_TYPES.DEFAULT_INVERTED ? (
              <img
                style={{
                  width: styles.icon.width,
                  height: styles.icon.height,
                  color: 'black',
                }}
                src="/assets/icons/checkbox-unselected-inverted.svg"
              />
            ) : null}

            {props.type == ICON_TYPES.CIRCLE ? (
              <img
                style={{
                  width: styles.icon.width,
                  height: styles.icon.height,
                }}
                src="/assets/icons/checkbox-circle-unselected.svg"
              />
            ) : null}
          </>
        )}
      </div>

      {props.text ? (
        <div style={styles.labelContainer}>
          <span
            className={props.textClassName ? props.textClassName : ''}
            style={
              props.textStyle
                ? {
                    ...props.textStyle,
                  }
                : { ...styles.label }
            }
          >
            {isHTML(props.text) ? (
              <p dangerouslySetInnerHTML={{ __html: props.text }} />
            ) : (
              props.text
            )}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default memo(Checkbox);
